import React from "react";
import { NavLink, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Offcanvas from 'react-bootstrap/Offcanvas';



const Navigation = ({ toggleMenuClass, isHomepage }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const toggleMenu = () => {
    setShow(!show)
    toggleMenuClass();
  }


  return (
    <>
      

      <nav className={`navbar ${isHomepage ? 'hide-navigation' : ''}`}>
        <div className="container">

          <div id="mob-nav" onClick={toggleMenu}>
            <span className="slice1"></span>
            <span className="slice2"></span>
            <span className="slice3"></span>
          </div>

        </div>
      </nav>

      <Offcanvas show={show} onHide={handleClose} onHide={toggleMenu} placement="start">
       

        <Offcanvas.Body>

          <nav className="mobmenu">
            <div className="container">
              <ul>
                <li>
                  <NavLink to="/" onClick={toggleMenu}>
                  Home
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/welcome" onClick={toggleMenu}>
                  Welcome
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/peter-frankopan" onClick={toggleMenu}>
                    <strong>Looking back to look forward</strong><br/>
                    <em>Peter Frankopan</em> says that the latest technologies are shedding new light on the past
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/miranda-malins" onClick={toggleMenu}>
                  <strong>Heads and tales</strong><br/>
                  <em>Miranda Malins</em> on what a republican ‘coronation’ some 365 years ago can tell us about today’s monarchy
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/melissa-harrison" onClick={toggleMenu}>
                  <strong>How does your garden grow?</strong><br/>
                  <em>Melissa Harrison</em> on how Britain’s 30 million gardens might help address the linked issues of climate change and biodiversity loss
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/jenny-natusch" onClick={toggleMenu}>
                  <strong>Teen spirit</strong><br/>
                  <em>Jenny Natusch</em> is a social entrepreneur on a mission to turn the tide in how we support our young people
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/vaseem-khan" onClick={toggleMenu}>
                  <strong>The never-ending Golden Age of Golden Age crime fiction</strong><br/>
                  <em>Vaseem Khan</em> on the enduring legacy of the whodunnit and how the very worst can bring out the very best in us
                </NavLink>
                </li>
                <li>
                  <NavLink to="/james-holland" onClick={toggleMenu}>
                  <strong>Method, motivation and morale</strong><br/>
                  <em>James Holland</em> says business could learn a thing or three from the RAF’s wartime effort
                </NavLink>
                </li>
                <li>
                  <NavLink to="/michael-taylor" onClick={toggleMenu}>
                  <strong>Digging up the past</strong><br/>
                <em>Michael Taylor</em> explains how scientists used dinosaurs to explain the mysteries of evolution
                </NavLink>
                </li>
                <li>
                  <NavLink to="/jonathan-wilson" onClick={toggleMenu}>
                  <strong>A prophecy fulfilled</strong><br/>
                  <em>Jonathan Wilson</em> explains how in a little over a century the biggest celebrity in Argentina changed from being an imported bull to an exported footballer
                </NavLink>
                </li>
                <li>
                  <NavLink to="/adam-rutherford" onClick={toggleMenu}>
                  <strong>Running in the family</strong><br/>
                  <em>Adam Rutherford</em> takes us back to some very inbred royals, who just didn’t know their maths, but he’s the bringer of good news for literally all of us
                </NavLink>
                </li>
                <li>
                  <NavLink to="/alex-massie" onClick={toggleMenu}>
                  <strong>Keeping your spirits up</strong><br/>
                  <em>Alex Massie</em> on how three women on a Scottish island resorted to gin, though not in the way you might think
                </NavLink>
                </li>
                <li>
                  <NavLink to="/additional-information" onClick={toggleMenu}>
                  Additional Information
                  </NavLink>
                </li>
                <li>
                  <NavLink to="https://www.rathbones.com">
                  Return to Rathbones homepage
                  </NavLink>
                </li>
              </ul>

            </div>
          </nav>

        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}



export default Navigation;
